<template>
  <div></div>
</template>

<script>
/* eslint-disable */
import { getCookie } from '@/utils/index.js'
import { uuid } from '@/utils/uuid.js'
export default {
  name: 'author',
  activated () {
    console.log(this.$route.query.code)
    console.log(this.$route.query.errorCode)
    if (this.$route.query.code) {
      this.authenticationWxOauth()
    }
    if (this.$route.query.errorCode == -998 || this.$route.query.errorCode == -999) {
      this.getClientCode()
    }
    if (this.$route.query.errorCode == 300013) {
      console.log(300013)
      // 接口告诉我没有授权，就往授权页跳
      let shareUrlNew = this.$store.state.ssoUrl + '/author.html?target=' + document.location.origin + '/index.html#/author'
      let locationHref = encodeURIComponent(shareUrlNew)
      console.log(locationHref)
      console.log('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.$store.state.appId + '&redirect_uri=' + locationHref + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect')
      window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.$store.state.appId + '&redirect_uri=' + locationHref + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect')
    }
  },
  methods: {
    getClientCode () { // 从localStorage中获取UUID
      if (!localStorage.getItem('STAR_GUEST_UUID')) { // localStorage没有UUID，重新生成一个
        localStorage.setItem('STAR_GUEST_UUID', uuid(32, 16))
      }
      this.authenticationApply()
    },
    authenticationApply () { // 申请令牌
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: self.$store.state.linkUrl + '/authentication/h5/apply',
          body: {
            appCode: self.$store.state.appId,
            clientCode: localStorage.getItem('STAR_GUEST_UUID')
          }
        })
        .then(res => {
          if (res.success) {
            localStorage.setItem('STAR_GUEST_TOKEN', res.data.tk)
            console.log(getCookie('beforeLoginUrl'))
            self.goBeforeLoginUrl() // 页面恢复(进入用户一开始请求的页面)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    authenticationWxOauth () { // 微信授权
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: self.$store.state.linkUrl + '/authentication/h5/wx/oauth',
          params: {
            code: self.$route.query.code,
            appId: self.$store.state.appId,
            scope: 'snsapi_userinfo'
          }
        })
        .then(res => {
          if (res.success) {
            console.log(getCookie('beforeLoginUrl'))
            self.goBeforeLoginUrl() // 页面恢复(进入用户一开始请求的页面)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/author.vue